import { render } from "./HealthCheckLogs.vue?vue&type=template&id=2524f42c&scoped=true"
import script from "./HealthCheckLogs.vue?vue&type=script&lang=js"
export * from "./HealthCheckLogs.vue?vue&type=script&lang=js"

import "./HealthCheckLogs.vue?vue&type=style&index=0&id=2524f42c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2524f42c"]])

export default __exports__